function Footer() {
  return (
    <div id="footer">
      <div>
        <p>Detective Conan © by Gosho Aoyama/Shogakukan.</p>
        <p>Detective Conan TCG © by TOMY.</p>
        <a target="_blank" href="https://github.com/write-code-b/Conan-Card">
          © 2024 website by @write_code_b
        </a>
        <a target="_blank" href="https://icons8.com">
          icon by Icons8
        </a>
      </div>
      <div>
        <p>카드 일한 번역자_장윤식</p>
      </div>
      <div></div>
    </div>
  );
}

export default Footer;
